import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

export const useDropzoneUpload = ({ accept, buildFormData, uploadFn, onSuccess, onError }) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach(async (archivo) => {
        try {
          const formData = buildFormData(archivo)
          await uploadFn(formData)
          onSuccess?.(archivo)
        } catch (error) {
          onError?.(error)
        }
      })
    },
    [buildFormData, uploadFn, onSuccess, onError]
  )

  return useDropzone({ onDrop, accept })
}
